import SetupPin from "../../container/Pincode/SetupPin";

const Pincode = () => <SetupPin />;

export default Pincode;
